module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAdCAYAAADPa766AAAABHNCSVQICAgIfAhkiAAAAUBJREFUSInVlWtuwzAMg7lhB9NO5vVkcU/W/bEwVpX8kJMNI2CkcRzy86MKkJcAOFp7tGvZ8EuFPwatXAElzdQCHO2Z0JgIahvAm70CRNLV2FqlbHgPyvMrkd/ZABGU51+iAWeGR0A2s+AXAawEz7vg0l1ZDyzA0z9r+VCdEK4t9D+zHkQAXI2HytaDXrjQmGkQC9XbOgnGHPTcwk6B6ErY2QvireuVAMHPB1LBpkCi2VtYXQUO4XAF8CCXQCKgzBnZAtHA3hnRczI6oAWT4T0QVuaMeCAH+3+s0DXdWlMTMc/qhIfQe7csCIfydUUVwCd37IDsqvLN+x9BvOjfgMgFmXVlsGDiM5306xVDV1ygtGhlAGzdcfU2MCoAvkwf39877ymIqmK+zoSmM9V0pcq+aLQiHhTImAOq+X13+kN9A3d+CNP9Rh2pAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Tjianlilaoshi.png
// module id = +K2g
// module chunks = 1